var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { st, classes } from './Toast.st.css';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { CloseIconButton } from './CloseIconButton';
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnCloseClick = function (event) {
            var onClose = _this.props.onClose;
            onClose && onClose(event);
        };
        return _this;
    }
    Toast.prototype.render = function () {
        var _this = this;
        var _a = this.props, skin = _a.skin, shouldShowCloseButton = _a.shouldShowCloseButton, children = _a.children, shouldAnimate = _a.shouldAnimate, isShown = _a.isShown, placement = _a.placement, className = _a.className;
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile, rtl = _a.rtl;
            return (React.createElement("div", { className: st(classes.root, { mobile: mobile, skin: skin, shouldAnimate: shouldAnimate, isShown: isShown, placement: placement, rtl: rtl }, className), role: "alert", "data-is-shown": isShown, "data-skin": skin, "data-mobile": mobile, "data-hook": _this.props['data-hook'] },
                React.createElement("span", { role: "presentation", className: classes.gapBeforeMessage }),
                React.createElement("span", { className: classes.message, "data-hook": "message" }, children),
                shouldShowCloseButton ? (React.createElement("div", { className: classes.closeButtonWrapper },
                    React.createElement(CloseIconButton, { onClick: _this.handleOnCloseClick, "data-hook": "closeButton" }))) : (React.createElement("span", { role: "presentation", className: classes.gapAfterMessage }))));
        }));
    };
    Toast.displayName = 'Toast';
    Toast.defaultProps = {
        shouldShowCloseButton: false,
        isShown: true,
    };
    return Toast;
}(React.Component));
export { Toast };
//# sourceMappingURL=Toast.js.map